module.exports = __webpack_public_path__ + "img/m_course_mvp.e6b3df8e.jpg";